<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 417 417"
		xmlns="http://www.w3.org/2000/svg"
		:fill="color"
		:class="customClass"
	>
		<g transform="translate(0.000000,417.000000) scale(0.100000,-0.100000)">
			<path
				d="M2345 3879 c-345 -33 -589 -193 -776 -507 -72 -121 -115 -210 -224
-462 -189 -440 -258 -560 -366 -644 -160 -125 -413 -94 -683 82 -68 45 -85 52
-129 52 -60 0 -109 -27 -130 -73 -25 -53 -40 -183 -33 -282 15 -201 73 -400
181 -620 249 -507 679 -907 1139 -1060 162 -54 235 -66 427 -72 534 -16 974
117 1313 399 349 290 565 776 612 1380 l7 88 36 9 c20 6 110 29 201 52 151 39
168 46 203 80 35 35 37 40 37 100 l0 63 -97 96 c-54 52 -182 175 -284 272
l-186 177 -28 78 c-15 43 -50 123 -77 178 -128 254 -283 419 -493 521 -115 56
-215 81 -372 94 -138 11 -160 11 -278 -1z m430 -323 c105 -34 170 -72 251
-148 114 -108 197 -242 269 -442 19 -54 41 -108 48 -121 6 -12 94 -100 195
-195 100 -95 181 -174 180 -175 -2 -2 -57 -17 -122 -34 -193 -50 -197 -56
-208 -260 -17 -322 -83 -612 -193 -837 -215 -442 -616 -698 -1179 -753 -312
-31 -510 1 -751 118 -150 74 -269 158 -402 285 -272 259 -481 615 -547 932 -8
38 -13 70 -12 72 2 1 37 -11 79 -28 125 -50 238 -73 362 -73 172 1 303 44 425
142 155 125 227 247 445 752 53 123 122 273 152 332 122 239 257 371 439 431
93 30 138 35 314 32 157 -3 183 -6 255 -30z"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: "ChickIcon",
	props: {
		size: {
			type: [String, Number],
			default: 24,
		},
		color: {
			type: String,
			default: "currentColor",
		},
		customClass: {
			type: String,
			default: "",
		},
	},
}
</script>

<style scoped>
svg {
	display: inline-block;
	vertical-align: middle;
}
</style>
